import { useState, useEffect } from 'react'
import Tabs from '@cloudscape-design/components/tabs'
import { AdHocRunSection } from '@/components/benchmark/AdHocRunSection'
import { SchedulerSection } from '@/components/benchmark/SchedulerSection'
import { cleanupStaleState } from '@/engine/scheduler-singleton'

export function BenchmarkPage() {
  const [activeTab, setActiveTab] = useState('run-now')

  useEffect(() => {
    cleanupStaleState()
  }, [])

  return (
    <Tabs
      activeTabId={activeTab}
      onChange={({ detail }) => setActiveTab(detail.activeTabId)}
      tabs={[
        {
          id: 'run-now',
          label: 'Run Now',
          content: <AdHocRunSection />,
        },
        {
          id: 'schedule',
          label: 'Schedule',
          content: <SchedulerSection />,
        },
      ]}
    />
  )
}
